import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import {
  Table,
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Navbar,
  Nav,
} from "react-bootstrap";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../css/DistributionEmpTable.css";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import { ThemeContext } from "../context/ThemeContext";
import { useEmployeesContext } from "../hooks/useEmployeesContext";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";

function DistributionEmpTable() {
  const { employees, dispatch } = useEmployeesContext();
  const [selectedEmp, setselectedEmp] = useState();
  const [isSubscribed, setIsSubscribed] = useState(false);


  //Recyling REV ID 
  const location = useLocation();
  const { RevID } = location.state;

  const { user } = useAuthContext();


  //Driver Context
  const { settransportDriver } = useContext(ThemeContext);

  useEffect(() => {
    const fetchDrivers = async () => {
      const response = await fetch("/api/user", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();

      if (response.ok) {
        dispatch({ type: "GET_AVAILABLE_DRIVERS", payload: json });
      }
    };

    fetchDrivers();
  }, [dispatch]);


  //checkbox handling
  const handleselectedDriver = (e, emp) => {
    e.preventDefault();
    if (e.target.checked) {
      console.log("✅ Checkbox is checked");
      setselectedEmp(emp);
      settransportDriver(emp);
    } else {
      console.log("⛔️ Checkbox is NOT checked");
      setselectedEmp(null);
      settransportDriver(null);
    }
    if (selectedEmp != null) {
      console.log(selectedEmp.firstName + "----" + emp.status);
    } else {
      console.log("Loading...");
    }

    setIsSubscribed((current) => !current);
  };

  const handleAssignDriver = async (e) => {
    const response = await fetch("/api/user/qa/" + selectedEmp._id, {
      method: "PATCH",
      body: JSON.stringify(selectedEmp),

      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    const json = await response.json();
    if (!response.ok) {
      console.log("Request Failed");
    }
  };

  //   const assignDriver = async(e, id) => {
  //     const response = await fetch('/api/employees/' + id,{
  //         method: 'GET'
  //     })
  //     const json = await response.json()

  //     if(response.ok){
  //         dispatch({type:'SET_EMPLOYEES',payload:json})

  //       }
  //   }

  return (
    <div>
      {/* -------------------------------------------------- */}
      {/* ---------- ####### NAV BAR START #######---------- */}
      {/* -------------------------------------------------- */}
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="dark"
        sticky="top"
        className="nav-bar-edit"
      >
        <Container>
          <Navbar.Brand>Assign Available Drivers</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto"></Nav>
            <Nav>
              <Navbar.Text className="nav-component nav-user-name"></Navbar.Text>
              <Link
                to="/qualityassurance"
                className="btn btn-primary mr-2 nav-component nav-link-btn "
              >
                QA Sessions
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* ------------------------------------------------ */}
      {/* ---------- ####### NAV BAR END #######---------- */}
      {/* ------------------------------------------------ */}

      <div className="content">
        <h1 className="table-name">
          <span>Assign Available Drivers</span>
        </h1>
        <h2 className="table-info">
          Include a brief form description in the section here.
        </h2>

        {/* ---------------------------------------------------------------- */}
        {/* ---------- ####### ENTIRE COLUMN SECTION START #######---------- */}
        {/* ---------------------------------------------------------------- */}
        <div className="row card-section-2">
          {/* ---------------------------------------------------------- */}
          {/* ---------- ####### EMPLOYEES TABLE START #######---------- */}
          {/* ---------------------------------------------------------- */}
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Employees</h5>
                <p className="card-text">Below is a list of idle employees</p>
                <table className="table table-bordered table-qa-emp">
                  <thead>
                    <tr>
                      <th scope="col">Assign</th>
                      <th scope="col">Name</th>
                      <th scope="col">Contact No.</th>
                      <th scope="col">Type of Employee</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employees &&
                      employees.map((emp) => (
                        <tr key={emp._id}>
                          <th scope="row">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexCheckDefault"
                              value={isSubscribed}
                              onChange={(e) => handleselectedDriver(e, emp)}
                            />
                          </th>
                          <td>{emp.firstName}</td>
                          <td>{emp.phone}</td>
                          <td>{emp.typeOfEmp}</td>
                          <td>{emp.status}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* -------------------------------------------------------- */}
          {/* ---------- ####### EMPLOYEES TABLE END #######---------- */}
          {/* -------------------------------------------------------- */}
        </div>
        {/* -------------------------------------------------------------- */}
        {/* ---------- ####### ENTIRE COLUMN SECTION END #######---------- */}
        {/* -------------------------------------------------------------- */}

        <div className="d-grid gap-2 card-section-whole">
          <Link to={"/DistributionForm"} state={{ RevID: RevID }}>
            <Button
              variant="success"
              type="Submit"
              className="filter-btn"
              onClick={(e) => {
                handleAssignDriver(e);
              }}
            >
              Assign Employee For Distribution
            </Button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DistributionEmpTable;
